export const POPULAR_CITIES = [
  { label: 'Los Angeles, CA', value: 'us_ca_los_angeles', lat: 34.0522, lng: -118.2437 },
  { label: 'San Francisco, CA', value: 'us_ca_san_francisco', lat: 37.7749, lng: -122.4194 },
  { label: 'New York, NY', value: 'us_ny_new_york', lat: 40.7128, lng: -74.006 },
  { label: 'Austin, TX', value: 'us_tx_austin', lat: 30.2672, lng: -97.7431 },
  { label: 'Seattle, WA', value: 'us_wa_seattle', lat: 47.6062, lng: -122.3321 },
  { label: 'Portland, OR', value: 'us_or_portland', lat: 45.5155, lng: -122.6789 },
  { label: 'Chicago, IL', value: 'us_il_chicago', lat: 41.8781, lng: -87.6298 },
  { label: 'Denver, CO', value: 'us_co_denver', lat: 39.7392, lng: -104.9903 },
] as const;

export const PRODUCT_CATEGORIES = [
  { value: 'breads', label: 'Breads' },
  { value: 'pastries', label: 'Pastries' },
  { value: 'cakes', label: 'Cakes' },
  { value: 'cookies', label: 'Cookies' },
  { value: 'desserts', label: 'Desserts' },
  { value: 'beverages', label: 'Beverages' },
  { value: 'food', label: 'Food' },
  { value: 'catering', label: 'Catering' },
  { value: 'custom_orders', label: 'Custom Orders' },
  { value: 'service', label: 'Service' },
] as const;

export const ITEM_EMOJI: Record<string, { emoji: string; gradient: string }> = {
  breads:        { emoji: '🍞', gradient: 'from-amber-100 to-yellow-50' },
  pastries:      { emoji: '🥐', gradient: 'from-orange-100 to-amber-50' },
  cakes:         { emoji: '🎂', gradient: 'from-pink-100 to-rose-50' },
  cookies:       { emoji: '🍪', gradient: 'from-amber-100 to-orange-50' },
  desserts:      { emoji: '🍰', gradient: 'from-rose-100 to-pink-50' },
  beverages:     { emoji: '☕', gradient: 'from-emerald-100 to-green-50' },
  food:          { emoji: '🍽️', gradient: 'from-red-100 to-orange-50' },
  catering:      { emoji: '🎉', gradient: 'from-violet-100 to-purple-50' },
  custom_orders: { emoji: '✨', gradient: 'from-indigo-100 to-blue-50' },
  service:       { emoji: '🔧', gradient: 'from-teal-100 to-cyan-50' },
};

export type PopularCity = (typeof POPULAR_CITIES)[number];
export type ProductCategory = (typeof PRODUCT_CATEGORIES)[number];


export const LA_NEIGHBORHOODS = [
  'Downtown',
  'Torrance',
  'Sawtelle',
  'Long Beach',
  'Downey',
  'Koreatown',
  'Hollywood',
  'Silver Lake',
  'Echo Park',
  'Santa Monica',
] as const;
